export class StringUtil {

  public static reformatString(string?: string): string | undefined {
    if (!string) {
      return undefined;
    }
    let persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g];
    let arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g];
    for (let i = 0; i < 10; i++) {
      string = string!.replace(persianNumbers[i], '' + i).replace(arabicNumbers[i], '' + i);
    }
    return string;
  }

  public static isPhoneNumberValid(phoneNumberText: string): boolean {
    return (phoneNumberText.length === 10 && phoneNumberText.trim().startsWith('9')) || (phoneNumberText.length === 11 && phoneNumberText.trim().startsWith('0')) || (phoneNumberText.length === 13 && phoneNumberText.trim().startsWith('+989'));
  }

  public static refactorPhoneNumber(phoneNumber: string): string {
    let result: string = phoneNumber.trim();
    if (phoneNumber.charAt(0) == '0') {
      result = phoneNumber.substring(1);
    } else if (phoneNumber.startsWith('+989')) {
      result = phoneNumber.substring(3);
    }
    result = "0" + result;
    return result;
  }

  public static integerAsCurrency(integer?: number | string): string {
    if (!integer) {
      return '0';
    }
    if (typeof integer === 'string') {
      integer = parseInt(integer);
    }
    integer = parseInt(integer.toFixed(0));
    let isNegative = (integer < 0);
    integer = Math.abs(integer);
    let result: string = '';
    while (integer != 0) {
      let temp = '' + (integer % 1000);
      if (temp.length === 1) {
        temp = '00' + temp;
      } else if (temp.length === 2) {
        temp = '0' + temp;
      }
      result = temp + ',' + result;
      integer = (n => n < 0 ? Math.ceil(n) : Math.floor(n))(integer / 1000);
    }
    if (result.length > 0) {
      result = result.substring(0, result.length - 1);
      if (((str, searchString, position = 0) => str.substr(position, searchString.length) === searchString)(result, '00')) {
        result = result.substring(2);
      } else if (((str, searchString, position = 0) => str.substr(position, searchString.length) === searchString)(result, '0')) {
        result = result.substring(1);
      }
    }
    if (result === ('')) {
      result = '0';
    }
    return isNegative ? ('-' + result) : result;
  }

  public static formatAmount(amount: any): string {
    const numericAmount = parseFloat(amount);

    if (!isNaN(numericAmount)) {
      return numericAmount.toLocaleString(undefined, {
        maximumFractionDigits: 0,
        minimumFractionDigits: 0,
      });
    }

    return '';
  }

  public static convertNumberToPersianWords(num: number): string {
    const ones = ['', 'یک', 'دو', 'سه', 'چهار', 'پنج', 'شش', 'هفت', 'هشت', 'نه'];
    const tens = ['', 'ده', 'بیست', 'سی', 'چهل', 'پنجاه', 'شصت', 'هفتاد', 'هشتاد', 'نود'];
    const hundreds = ['', 'صد', 'دویست', 'سیصد', 'چهارصد', 'پانصد', 'ششصد', 'هفتصد', 'هشتصد', 'نهصد'];
    const thousands = ['', 'هزار', 'میلیون', 'میلیارد', 'تریلیون'];

    if (num === 0) {
      return 'صفر';
    }

    let words = '';
    let i = 0;

    while (num > 0) {
      if (num % 1000 !== 0) {
        const word = this.convertLessThanOneThousand(num % 1000, ones, tens, hundreds);
        words = word + thousands[i] + ' ' + words;
      }
      num = Math.floor(num / 1000);
      i++;
    }

    return words.trim();
  }

  public static convertLessThanOneThousand(num: number, ones: string[], tens: string[], hundreds: string[]): string {
    let word = '';

    if (num % 100 < 10) {
      word = ones[num % 100];
      num = Math.floor(num / 10);
      if (num > 0) {
        word = tens[num % 10] + ' و ' + word;
        num = Math.floor(num / 10);
      }
    } else if (num % 100 < 20) {
      word = ones[num % 100];
      num = Math.floor(num / 100);
      if (num > 0) {
        word = hundreds[num % 10] + ' و ' + word;
        num = Math.floor(num / 10);
      }
    } else {
      word = ones[num % 10];
      num = Math.floor(num / 10);
      word = tens[num % 10] + ' ' + word;
      num = Math.floor(num / 10);
      word = hundreds[num % 10] + ' و ' + word;
      num = Math.floor(num / 10);
    }

    if (num > 0) {
      word = hundreds[num % 10] + ' و ' + word;
    }

    return word;
  }

  public static removeCommasAndConvertToNumber(value: string): number {
    const numberWithNoCommas = value.replace(/,/g, '');
    return parseInt(numberWithNoCommas, 10);
  }

}
